export default __webpack_public_path__ + "static/media/headerbgmaing2.392ee08f.png";